import '~/styles/theme.scss';
import '~/styles/giftcard.scss';

import Vue from 'vue';
import store from '~/store';

import LayoutDefault from '~/components/layout/LayoutDefault'

import PageError from '~/components/page/PageError'
import PageHome from '~/components/page/PageHome'
import PageCollection from '~/components/page/PageCollection'
import PageProduct from '~/components/page/PageProduct'
import PageBlog from '~/components/page/PageBlog'
import PageArticle from '~/components/page/PageArticle'
import PageCart from '~/components/page/PageCart'
import PageSearch from '~/components/page/PageSearch'

import PageDefault from '~/components/page/PageTemplateDefault'
import PageStockists from '~/components/page/PageTemplateStockists'

import CommonLinks from '~/components/common/CommonLinks'
import StockistSection from '~/components/stockist/StockistSection'

Vue.mixin({
  methods: {
    getKey() {
      const args = Array.from(arguments).join('_');

      return `${args}`;
    },
  }
})

Vue.component('CommonLinks', CommonLinks)

new Vue({
  el: '#app',
  components: {
    LayoutDefault,

    PageError,
    PageHome,
    PageCollection,
    PageProduct,
    PageBlog,
    PageArticle,
    PageCart,
    
    PageDefault,
    PageStockists,
    PageSearch,

    StockistSection,
    
  },
  store,
});  
